import { CmsComponentMapping, CmsDefaultComponent } from '@domgen/dgx-fe-cms';
import {
  ContactUsComponent,
  ContactUsPanelBlockComponent,
} from '@support/feature-contact-us';
import { ContentComponent } from '@support/feature-content';

export const SUPPORT_CMS_COMPONENT_MAPPING: CmsComponentMapping = {
  'dgx-support:pages/contact-us': ContactUsComponent,
  'dgx-support:pages/content': ContentComponent,
  'dgx-support:pages/index': CmsDefaultComponent,
  'dgx-support:components/panels/contact-us-panel-block':
    ContactUsPanelBlockComponent,
};
